import { SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { Colors } from '../../themes/colors';
import { Row } from '../Row';

interface IProps {
  text: string;
  extraText?: string;
  error?: boolean;
  marginBottom?: number;
  required?: boolean;
  withoutOptionalMarker?: boolean;
}

export const Label = ({
  text,
  extraText,
  error = false,
  marginBottom = 8,
  required = true,
  withoutOptionalMarker = false,
}: IProps) => (
  <Row data-testid="label" gap={4} style={{ marginTop: 0, marginBottom }}>
    <span className="input_names" style={{ width: 'fit-content' }}>
      {text}
    </span>
    {extraText && (
      <span
        style={{
          color: Colors.neutral_500,
          fontWeight: 400,
          fontSize: 16,
        }}
      >
        {` ${extraText}`}
      </span>
    )}
    {!required && !withoutOptionalMarker && (
      <span
        style={{
          color: Colors.neutral_500,
          fontWeight: 400,
          fontSize: 16,
        }}
      >
        {' (Optional)'}
      </span>
    )}

    {error && <SolidExclamationWarningAlertIcon color={colors.warning[500]} />}
  </Row>
);
